const minin = {
  data() {
    return {
      baseUrl: 'staff',
      tabIdx: 0,
      tabData: [
        {
          slot: "first",
          name: "在职",
        },
        {
          slot: "second",
          name: "离职",
        },
        {
          slot: "third",
          name: "冻结",
        },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "姓名",
          keyName: "name",
          placeholder: "请填写姓名",
          type: "text",
        },
        /*{
          label: "性别：",
          keyName: "sex",
          placeholder: "请选择性别",
          type: "select",
          options: [
            { label: '男', value: '男' },
            { label: '女', value: '女' },
          ],
        },
        {
          label: "出生年月：",
          keyName: "birthday",
          placeholder: "请选择出生年月",
          type: "date",
        },*/
      ],
      cols: [
        { prop: "name", label: "姓名" },
        { prop: "sex", label: "性别" },
        //{ prop: "age", label: "年龄" },
        { prop: "tel", label: "联系方式" },
        { prop: "nation", label: "民族" },
        //{ prop: "iswork", label: "状态" },
        { prop: "province", label: "籍贯" },
        { prop: "edu", label: "学历" },
      ],
      baseParams: ['iswork', 'user_group_id'],
    };
  },
  watch: {
    $route() {
      // console.log(from.path, to.path)
      // console.log(this.$route.params)
      const { iswork } = this.$route.params
      this.formInline.iswork = iswork || 1
      this.getList()
      // console.log(iswork)
    },
  },
  methods: {
    delParamsPackage(params) {
      params['headers'] = {
        'X-Method': 'delete',
        'X-Module': 'staff',
      }

      // console.log('params', { ...params })
    },

    onToggleTab({ index }) {
      this.tabIdx = index;
      switch (index) {
        case '0':
          this.formInline.iswork = 1
          break;
        case '1':
          this.formInline.iswork = 2
          break;
        case '2':
          this.formInline.iswork = 3
          break;
      }
      this.getList();
    },
    getCaptains() {
      this.loading = true
      let url = `fixedpay/getfleet`;
      const params = {
        userid: this.user.id,
      }
      this.post(url, params, ({ fleet }) => {
        this.loading = false
        this.radioData = fleet.map(v => {
          return {
            label: v.nickname,
            value: v.id,
          }
        })
        this.formInline.fleet = fleet[0].id
        this.$nextTick(() => {
          this.getList()
        })
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    radioChange(v) {
      // console.log(v)
      this.formInline.fleet = v
      this.getList();
    },
  },
  mounted() {
    const { iswork } = this.$route.params
    this.formInline.iswork = iswork
    if (iswork) {
      this.getList()
    }
  },
}

export default minin